import { Component } from '@angular/core';

@Component({
  selector: 'app-e-buro',
  templateUrl: './e-buro.component.html',
  styleUrls: ['./e-buro.component.scss']
})
export class EBuroComponent {

}
